"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var owa_bundling_1 = require("owa-bundling");
owa_bundling_1.preloadScriptChunk('PersonaHeaderFirstRun');
var lazyModule = new owa_bundling_1.LazyModule(function () {
    return System.import(/* webpackChunkName: "PersonaHeaderFirstRun" */ './lazyIndex');
});
exports.PersonaHeaderFirstRun = owa_bundling_1.createLazyComponent(lazyModule, function (m) { return m.PersonaHeaderFirstRun; });
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/people/owa-people-persona-header-first-run-view/lib/index.js
// module id = 5975
// module chunks = 46